<template>
  <div class="comp-container">
    <div class="title">
      <img src="@saas/pages/assets/images/live-data/answer.png" alt="" />
      <p>答题器数据</p>
      <div class="more-btn" @click="handleClickMore">
        <span>查看全部</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="comp-content">
      <ul class="data-wrap">
        <li class="data-item" style="width: 112px; padding-left: 20px">
          <p class="data">{{ questionStaticData.total_num }}</p>
          <p class="data-name">题目数量</p>
        </li>
        <li class="data-item center" style="width: 120px">
          <div>
            <p class="data duration-time">
              {{ questionStaticData.total_user_num }}
            </p>
            <p class="data-name">参与学生</p>
          </div>
        </li>
        <li class="data-item" style="width: 132px">
          <p class="data">{{ questionStaticData.avg_right_rate }}%</p>

          <div class="data-name">
            平均正确率
            <el-tooltip
              class="item"
              effect="dark"
              content="平均正确率= 学生的正确率之和/学生的总人数（不包含未参加直播的学生）"
              placement="top-start"
            >
              <img src="@saas/pages/assets/images/live-data/tips.png" alt="" />
            </el-tooltip>
          </div>
        </li>
        <li class="data-item">
          <p class="data">
            {{ formatTimeBySecond(questionStaticData.total_time) }}
          </p>
          <p class="data-name">总用时</p>
        </li>
      </ul>
    </div>
    <ClickerDataDialog
      :visible.sync="dialogVisible"
      :liveReport="liveReport"
    ></ClickerDataDialog>
  </div>
</template>

<script>
import ClickerDataDialog from "./ClickerDataDialog.vue";
import { formatTimeBySecond } from "@saas/components/src";
export default {
  components: {
    ClickerDataDialog,
  },
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  computed: {
    questionStaticData() {
      return this.liveReport.question_static_data || {};
    },
  },
  data() {
    return {
      dialogVisible: false,
      formatTimeBySecond,
    };
  },
  methods: {
    handleClickMore() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 590px;
  height: 274px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      margin-left: 8px;
    }
    .more-btn {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #4e5969;
      margin-right: 24px;
      cursor: pointer;
      i {
        margin-left: 2px;
        font-size: 12px;
        color: #4e5969;
      }
    }
  }
  .comp-content {
    padding-left: 24px;
    flex: 1;
    display: flex;
    align-items: center;
    .data-wrap {
      display: flex;
    }

    .data-item {
      padding: 0 0 0 28px;
      position: relative;
      .data.course-name {
        height: 56px;
        font-weight: 600;
        font-size: 20px;
        color: #0d1400;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .data {
        font-weight: bold;
        font-size: 36px;
        color: #0d1400;
        line-height: 42px;
        margin-bottom: 8px;
      }
      ::v-deep .sell-amount {
        padding-top: 14px;
        font-weight: bold;
        color: #f03349;
        .symbol {
          font-weight: 600;
          font-size: 19px;
          line-height: 26px;
        }
        .integer {
          font-size: 36px;
          line-height: 42px;
        }
        .decimal {
          font-size: 24px;
          line-height: 28px;
        }
      }
      .data-name {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-left: 2px;
        }
      }
      &::after {
        position: absolute;
        right: 0;
        top: 3px;
        display: block;
        content: "";
        width: 1px;
        height: 64px;
        background: linear-gradient(
          180deg,
          rgba(244, 244, 247, 0) 0%,
          #f2f2f5 14%,
          #e7e8ec 89%,
          rgba(229, 230, 235, 0) 100%
        );
      }
      &:last-child::after {
        display: none;
      }
      &.center {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
      }
    }
  }
}
</style>
